import { ChangeDetectionStrategy, Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { FeesFormField, FeesFormFieldOption } from '../fee-step.interface';
import {
  calculateFeeFormFieldTotal,
  calculateFeeFormGrandTotal,
  calculateFieldSubTotal,
  FEES_FORM_FIELD_TYPE,
  roundNumberToFixDigits,
} from '../fee-step.constants';
import { MASK_TYPE, NumberMaskConfig } from '@certemy/ui-components';
import { Store } from '@ngrx/store';
import { Selectors as ProfileSelectors } from 'features/profiles-state/+state/profiles-state.state';

@Component({
  selector: 'cm-fee-form-professional',
  templateUrl: './fee-form-professional.component.html',
  styleUrls: ['./fee-form-professional.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeeFormProfessionalComponent implements OnInit, OnChanges {
  @Input() feesFormFields: FeesFormField[];
  @Input() previewMode = false;
  @Input() isAdminPreview = false;
  @Input() feeAmount = 0;
  @Output() fieldsChange = new EventEmitter<FeesFormField[]>();
  numberMaskConfigForQuantity: NumberMaskConfig = {
    maskType: MASK_TYPE.POSITIVE_INTEGER,
    digitLimit: 3,
  };
  currencyIcon$ = this.store.select(ProfileSelectors.paymentSymbol);

  FIELD_TYPES = FEES_FORM_FIELD_TYPE;

  constructor(private store: Store<any>) {}

  ngOnInit() {
    this.feesFormFields = this.feesFormFields.map(field => ({
      ...field,
      options: field.options.map(option => {
        option.subtotal = this.calculateSubTotal(option, field.typeId);
        option.selected = !!option.quantity;
        return option;
      }),
    }));
  }

  ngOnChanges(changes) {
    if (changes.feesFormFields && changes.feesFormFields.currentValue) {
      this.feesFormFields = [...changes.feesFormFields.currentValue];
    }
  }

  onQuantityChange(quantity: number, option: FeesFormFieldOption, fieldTypeId: FEES_FORM_FIELD_TYPE) {
    option.quantity = quantity;
    option.subtotal = this.calculateSubTotal(option, fieldTypeId);
    this.fieldsChange.emit(this.feesFormFields);
  }

  calculateSubTotal(option: FeesFormFieldOption, fieldTypeId: FEES_FORM_FIELD_TYPE): number {
    return calculateFieldSubTotal(option, fieldTypeId);
  }

  onRadioClick(selectedOption: FeesFormFieldOption, field: FeesFormField) {
    if (this.previewMode) {
      return;
    }

    field.options.forEach(option => {
      option.selected = selectedOption.optionId === option.optionId;
      option.quantity = null;
      option.subtotal = 0;
    });

    this.fieldsChange.emit(this.feesFormFields);
  }

  calculateGrandTotal(): number {
    return roundNumberToFixDigits(this.feeAmount + calculateFeeFormGrandTotal(this.feesFormFields));
  }

  calculateFieldTotal(options: FeesFormFieldOption[], fieldTypeId: FEES_FORM_FIELD_TYPE): number {
    return calculateFeeFormFieldTotal(options, fieldTypeId);
  }

  getDiscountedPrice(option: FeesFormFieldOption): number {
    return roundNumberToFixDigits((1 - option.discountRate || 0) * option.price);
  }
}
